import ComponentRepository from './architecture/componentRepository';
import { articleAudioPlayer } from './components/article-audio-player';
import GPT from './architecture/GPT';

document.addEventListener('DOMContentLoaded', function () {
    articleAudioPlayer();
    window.cr = new ComponentRepository({
        'accordion': () => import('./components/accordion'),
        'navigation': () => import('./components/navigation'),
        'custom-select': () => import('./components/custom-select'),
        'hero-gallery': () => import('./components/hero-gallery'),
        'search': () => import('./components/search'),
        'follow-tag': () => import('./components/follow-tag'),
        'overview': () => import('./components/overview'),
        'overview-event': () => import('./components/overview-event'),
        'signup-page': () => import('./components/signup-page'),
        'tab-section': () => import('./components/tab-section'),
        'tab-section-accordion': () => import('./components/tab-section-accordion'),
        'form': () => import('./components/form'),
        'password': () => import('./components/password'),
        'register-step-2': () => import('./components/register-step-2'),
        'register-step-5': () => import('./components/register-step-5'),
        'my-page-tabs-swiper': () => import('./components/my-page-tabs-swiper'),
        'product-card': () => import('./components/product-card'),
        'my-page-modal': () => import('./components/my-page-modal'),
        'confirm-modal': () => import('./components/confirm-modal'),
        'feedback-modal': () => import('./components/feedback-modal'),
        'my-page-subscription': () => import('./components/my-page-subscription'),
        'my-page-address': () => import('./components/my-page-address'),
        'slider-section-slider': () => import('./components/slider-section-slider'),
        'mailerlite-newsletter-form': () => import('./components/mailerlite-newsletter-form'),
        'adblock-detector': () => import('./components/adblock-detector'),
        'btn-loader': () => import('./components/btn-loader'),
        'search-overview': () => import('./components/search-overview'),
        'tag-overview': () => import('./components/tag-overview'),
        'my-page-tilmelding': () => import('./components/my-page-tilmelding'),
        'gp-voting': () => import('./components/gp-voting'),
        'frontpage-event': () => import('./components/frontpage-event'),
    });
    window.gpt = new GPT();
});
